import { Fragment } from 'react';
const defaultPattern = /([^a-zA-Z0-9 ]+)/gu;

/**
 * Adds the <wbr> tag to a string based on the given regex pattern.
 * This is useful for specifying where the browser should split a long word.
 * (e.g. before the @ sign in an email).
 *
 * Read more:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/wbr
 * https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Text/Wrapping_Text
 *
 * NOTE this returns a JSX element
 *
 * @param text The text to break
 * @param pattern The regex pattern to split against
 * @returns
 */
export function addWordBreaks(text, pattern = defaultPattern) {
  if (!text) return '';
  return <>
			{text.split(pattern).map((segment, index) => <Fragment key={`${segment} ${index}`}>
					{pattern.test(segment) ? <wbr /> : null}
					{segment}
				</Fragment>)}
		</>;
}